import { ElementRef, inject, Signal } from '@angular/core';
import { EditorComponent } from '@tinymce/tinymce-angular';

export function registerPlainPaste(editorComponents: { tinyInline?: Signal<EditorComponent> }) {
  inject(ElementRef<HTMLElement>).nativeElement.addEventListener(
    'paste',
    (event: ClipboardEvent) => {
      event.preventDefault();
      event.stopPropagation();

      const plainText = event.clipboardData.getData('text/plain');

      const tiny = editorComponents.tinyInline();
      if (tiny) {
        document.execCommand('insertText', false, plainText);
      }
    },
    { capture: true }
  );
}
